<template>
    <div class="w-full space-y-3">
        <Head title="Queued Invoices Report"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Queued Invoices Report</h1>
        </div>
    </div>
    <br />
    <div class="mt-5 bg-white py-6 px-4 sm:p-6 shadow mb-6">
        <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Fixture
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Fixture Reference
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Fixture Date
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Queued At
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Client
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Raised
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Due
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Invoice Amount
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                            Invoice Reference
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="Object.values(invoices).length > 0" v-for="(invoice, index) in invoices" :key="index">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ invoice.fixture.title }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ invoice.fixture.reference }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ moment(invoice.fixture.starts_at, 'YYYY-MM-DD').format('DD MMM YYYY') }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ moment(invoice.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm') }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ invoice.fixture.client.name }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ moment(invoice.invoiceable.invoiced_at, 'DD-MM-YYYY').format('DD MMM YYYY') }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ moment(invoice.invoiceable.due_at, 'DD-MM-YYYY').format('DD MMM YYYY') }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            <span v-if="invoice.invoiceable.quote">
                                                {{ formatCurrency(invoice.invoiceable.amount, invoice.invoiceable.quote.sell_currency.code, true) }}
                                            </span>
                                            <span v-else>
                                                {{ formatCurrency(invoice.invoiceable.amount, invoice.invoiceable.fixture.currency.code, true) }}
                                            </span>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ invoice.invoiceable.reference }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment/moment";
    import pickBy from "lodash/pickBy";
    import debounce from "lodash/debounce";
    import Authenticated from "@/Layouts/Authenticated";
    import {Link, Head, usePage, useForm} from "@inertiajs/vue3";

    export default {
        layout: Authenticated,
        components: {
            Head,
            Link
        },
        created() {
            this.moment = moment
        },
        props: ['invoices', 'no_queue', 'starts_at', 'ends_at'],
        data(props) {
            return {
                form: useForm({
                    starts_at: props.starts_at,
                    ends_at: props.ends_at
                })
            }
        },
        computed: {
            formattedStartDate() {
                if (this.form.starts_at) {
                    return moment(this.form.starts_at).format('DD MMM YYYY');
                }
                return '';
            },
            formattedEndDate() {
                if (this.form.ends_at) {
                    return moment(this.form.ends_at).format('DD MMM YYYY');
                }
                return '';
            },
        },
        watch: {
            form: {
                deep: true,
                handler: debounce(function () {
                    this.$inertia.get(route('unit-4-settings.queued_invoices_report'), pickBy(this.form), {preserveState: true, preserveScroll: true})
                }, 500),
            },
        },
    }
</script>
